// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UploadDocumentRequestModel from '../../model/upload-document-request-model';
import UploadDocumentRequestDTO from '../dto/upload-document-request-dto';
import dtoSchema from '../schemas/upload-document-request-schema';

export default abstract class UploadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UploadDocumentRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;

  static toModel(dto: DeepPartial<UploadDocumentRequestDTO>): UploadDocumentRequestModel;
  static toModel(dto: DeepPartial<UploadDocumentRequestDTO> | undefined | null): UploadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<UploadDocumentRequestDTO> | undefined | null): UploadDocumentRequestModel | undefined {
    return dto ? new UploadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UploadDocumentRequestModel> | UploadDocumentRequestModel): UploadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
    } as UploadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UploadDocumentRequestModel, can not map to UploadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
